import React, { Component } from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
} from "recharts";

import Grid from "@material-ui/core/Grid";
import CustomTooltip from "./DoughnutTooltip";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "./../../../../Actions/Dashboard";

import { CUADRADO } from "../../../../constants//icons/characteristics/Characteristics";


import "./DoughnutStyle.css";

class DoughnutComponent extends Component {
  constructor(props) {
    super(props);
    let type = "doughnut";
    this.state = {
      type: type,
      colors: props.colors,
    };
  }

  getSvgArray = (colors) => {
    let data = this.props.data;
    let vect = [];
    for (let i = 0; i < data.length; i++) {
      vect.push(CUADRADO(colors[i % colors.length]));
    }
    return vect;
  };

  getPercentege = (val) => {
    const { data } = this.props;
    let sum = data.reduce((a, b) => ({ value: a.value + b.value })).value;
    return parseInt((val / sum) * 100) + "%";
  };

  render() {
    const { data } = this.props;
    const width = this.props.width ? this.props.width : 300
    const height = this.props.height ? this.props.height : 250
    const total = () => {
      var temp = 0;
      for (let i = 0; i < data.length; i++) {
        temp = temp + data[i].value;
      }
      return temp;
    };
    return (
      <Grid
        style={{ flexWrap: "inherit", margin: "auto" }}
        id={this.props.name}
        item
        xs={12}
      >
        <Grid
          container
          style={{ textAlign: "center", marginTop: "30px", marginBottom: "10px" }}
        >
          <Grid item xs={12}>
            <h2
              className="text-center client-label-second-color inline-block margin-left-20px"
              style={{ fontSize: "20px" }}
            >
              {this.props.title}
            </h2>
          </Grid>
        </Grid>
        <Grid>
          <Grid container >
            <Grid
              item
              xs={12}
              className="client-label "
            >
              <PieChart width={width} height={height} style={{ margin: "auto" }}>
                <Pie
                  data={this.props.data}
                  cx={"50%"}
                  cy={"50%"}
                  innerRadius={"30%"}
                  outerRadius={"95%"}
                  isAnimationActive={false}
                  onClick={() => { }}
                  className="on-mouse-hover"
                >
                  {this.props.data.map((entry, index) => (
                    <Cell
                      fill={
                        this.state.colors[index % this.state.colors.length]
                      }
                      key={"cell-pie-" + this.props.name + index}
                    />
                  ))}
                </Pie>
                <Tooltip
                  content={
                    <CustomTooltip
                      data={this.props.data}
                      colors={this.state.colors}
                      total={total()}
                      svgs={this.getSvgArray(this.state.colors)}
                    />
                  }
                />
              </PieChart>
            </Grid>
            <Grid container>
              <Grid item xs={1}></Grid>
              <Grid item xs={10} style={{ textAlign: 'left' }}>
                {this.props.data.map((entry, index) => (
                  <div
                    className="legend-box-inform"
                    key={"item-pie-" + this.props.name + index}
                  >
                    <div>
                      <svg
                        fill={this.state.colors[index % this.state.colors.length]}
                        height="8"
                        width="8"
                      >
                        {CUADRADO(this.state.colors[index % this.state.colors.length])}
                      </svg>
                    </div>
                    <p>{entry.name + ' - ' + entry.value + " - " + this.getPercentege(entry.value)}</p>
                  </div>
                ))}
              </Grid>
              <Grid item xs={1}></Grid>
            </Grid>
          </Grid>

        </Grid>
      </Grid>
    );
  }
}

function mapDispathToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}

export default connect(null, mapDispathToProps)(DoughnutComponent);
